import React from 'react';

import styled from '../../theme/styled-with-theme';
import { pxToRem } from '../../styles/utils';

import { BlockContainer, Layout, Column } from '../Layout';
import Link from '../Link';
import { RequestForm } from './RequestForm';

const HeaderWrapper = styled('div')`
  display: flex;
  align-items: center;
  justify-content: center;
`;

const FormHeader = styled('h3')`
  font-weight: normal;
  size: ${pxToRem(18)};
  line-height: ${pxToRem(21)};
`;

const ParagraphWrapper = styled('div')`
  text-align: center;
  padding-bottom: ${pxToRem(16)};
`;

const ParagraphWithBorder = styled(ParagraphWrapper)`
  border-bottom: solid ${pxToRem(1)}
    ${({ theme }) => theme.color.privacyTextBorderBottom};
`;

const BlockWrapper = styled(BlockContainer)`
  a {
    color: ${({ theme }) => theme.color.privacyLinkText};
  }
`;

export function DataRequest() {
  return (
    <BlockWrapper
      marginBottom={{ mobile: 'm', tablet: 'm', desktop: 'xl' }}
      marginTop={{
        0: 'blockMarginY',
        tablet: 'blockMarginY_tablet',
        desktop: 'xl'
      }}
      borderRadius={{ 0: 'block_desktop' }}
    >
      <Layout>
        <Column size={{ 0: 10 }} flexDirection="column">
          <ParagraphWrapper>
            We do not sell your personal information in exchange for money.
            However, if you are over age 18 we may share personal information
            with third parties for our own marketing purposes which could be
            considered a “sale” under the California Consumer Privacy Act.
          </ParagraphWrapper>
          <ParagraphWrapper>
            If you are a California resident you have the right to opt out from
            the “sale” of personal information. We also provide this opt-out
            right to residents of other states. If you would like to exercise
            this right, please complete the form below. If you would prefer to
            submit this request by email, you can submit the same information
            requested below by email to:{' '}
            <Link href="mailto:CAPrivacy@greenlight.com">
              CAPrivacy@greenlight.com
            </Link>{' '}
            with the subject line “California Sale Opt-Out Request”. Please note
            that these requests will opt out of sales that are tied to your name
            and Greenlight account.
          </ParagraphWrapper>
          <ParagraphWithBorder>
            In addition, where we use and share information related to your use
            of the Greenlight website or services (that is only tied to your
            browser or device) with third parties for our marketing purposes,
            you can use the <i>“Ad Choice Preferences”</i> tool to opt-out of
            this type of sharing. To access this Ad Choice Preference Tool,
            which only applies to information shared for online advertising
            purposes, please visit the home page of greenlight.com, scroll to
            the footer at the bottom, and click on{' '}
            <i>“Ad Choice Preferences”</i>. Because this information is tied to
            your device and browser (and not your name), you will need to
            complete a similar process for each browser used and across other
            websites you visit with the same device.
          </ParagraphWithBorder>
        </Column>
        <Column size={{ 0: 10 }} flexDirection="column">
          <HeaderWrapper>
            <FormHeader>
              If you are age 18 or older, please provide the following
              information so we can process your request:
            </FormHeader>
          </HeaderWrapper>
        </Column>
        <Column size={{ 0: 10 }} flexDirection="column">
          <RequestForm />
        </Column>
      </Layout>
    </BlockWrapper>
  );
}
